<template>
  <div v-if="couponList.length > 0">
    <div class="coupon-window" :class="value ? 'on' : ''">
      <div class="couponWinList">
        <div
          class="item acea-row row-between-wrapper"
          v-for="(item, index) in couponList"
          :key="index"
        >
          <div class="money font-color-red">
            ￥<span class="num">{{ parseInt(item.price) }}</span>
          </div>
          <div class="text">
            <div class="name">
              购物买{{ parseInt(item.full_price) }}减{{ parseInt(item.price) }}
            </div>
            <div v-if="item.end_time">
              {{ item.begin_time ? item.begin_time + "-" : ""
              }}{{ item.end_time }}
            </div>
          </div>
        </div>
        <div style="height:1.2rem"></div>
      </div>
      <div class="lid">
        <div class="bnt font-color-red" @click="checked">立即领取</div>
        <div class="iconfont icon-guanbi3" @click="close"></div>
      </div>
    </div>
    <div class="mask" @touchmove.prevent :hidden="!value"></div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import toLogin from "@libs/login";
import { getCouponReceive } from "@api/user";

export default {
  name: "CouponWindow",
  props: {
    couponList: {
      type: Array,
      default: () => []
    }
  },
  computed: mapGetters(["isLogin"]),
  data: function() {
    return {
      value: true
    };
  },
  mounted: function() {},
  methods: {
    checked() {
      const isLogin = this.isLogin;
      if (!isLogin) return toLogin();

      this.couponList.reduce(async (initial, coupon) => {
        if (!coupon.is_use) {
          // initial.push(coupon.id);
          await getCouponReceive({ coupon_id: coupon.id })
            .then(() => {
              this.$dialog.toast({ mes: "领券成功！" });
              this.$emit("success");
            })
            .catch(err => {
              this.$dialog.error(err);
            });
        }
        return initial;
      }, []);

      // couponReceiveBatch(ids)
      //   .then(() => {
      //     this.$emit("success");
      //     this.$dialog.toast({ mes: "领取成功" });
      //   })
      //   .catch(() => {
      //     this.$dialog.toast({ mes: "已领取" });
      //   });

      if (isLogin) {
        this.value = false;
        this.$emit("checked");
      }
    },
    close: function() {
      this.value = false;
      console.log("close");
      this.$emit("close");
    }
  }
};
</script>
